// extracted by mini-css-extract-plugin
export var boxContent = "style-module--boxContent--29a0e";
export var container = "style-module--container--0ae0c";
export var isologo = "style-module--isologo--f26dc";
export var subcontainer = "style-module--subcontainer--5a301";
export var text = "style-module--text--633a7";
export var titles = "style-module--titles--0011c";